import CheckboxField from "./CheckboxField.vue"
import CurrencyField from "./CurrencyField.vue"
import DateField from "./DateField.vue"
import DynamicPhoneField from "./DynamicPhoneField.vue"
import EmailField from "./EmailField.vue"
import Form from "./Form.vue"
import FormGroup from "./FormGroup.vue"
import NumberField from "./NumberField.vue"
import PhoneField from "./PhoneField.vue"
import PlusMinusField from "./PlusMinusField.vue"
import RadioField from "./RadioField.vue"
import SelectField from "./SelectField.vue"
import SsnField from "./SsnField.vue"
import StateField from "./StateField.vue"
import TextField from "./TextField.vue"
import ZipCodeField from "./ZipCodeField.vue"
import AppField from "./AppField.vue"

export default {
    install(Vue) {
        Vue.component("AppField", AppField)
        Vue.component("Form", Form)
        Vue.component("CheckboxField", CheckboxField)
        Vue.component("CurrencyField", CurrencyField)
        Vue.component("DateField", DateField)
        Vue.component("DynamicPhoneField", DynamicPhoneField)
        Vue.component("EmailField", EmailField)
        Vue.component("SelectField", SelectField)
        Vue.component("StateField", StateField)
        Vue.component("TextField", TextField)
        Vue.component("NumberField", NumberField)
        Vue.component("PhoneField", PhoneField)
        Vue.component("PlusMinusField", PlusMinusField)
        Vue.component("RadioField", RadioField)
        Vue.component("SsnField", SsnField)
        Vue.component("FormGroup", FormGroup)
        Vue.component("ZipCodeField", ZipCodeField)
    },
}
